$(document).ready(function () {
  $('.gcom-pageable').each(function (index, value) {
    $(value).find('.gcom-pageable-title').append('<a class="gcom-pageable-previous"></a><a class="gcom-pageable-next"></a>');
  });

  $('.gcom-pageable-previous').on('click', function() {
    let navigation = $(this).closest('.gcom-pageable').find('.vc_pagination');
    let page_count = $(navigation).find('.vc_pagination-item').length;
    let items = $(navigation).find('.vc_pagination-item').toArray();

    for(let i = 0; i < page_count; i++) {
      if($(items[i]).hasClass('vc_active')) {
        if(i === 0) {
          $(items[page_count - 1]).find('a').click();
        }
        else {
          $(items[i - 1]).find('a').click();
        }

        return true;
      }
    }
  });

  $('.gcom-pageable-next').on('click', function() {
    let navigation = $(this).closest('.gcom-pageable').find('.vc_pagination');
    let page_count = $(navigation).find('.vc_pagination-item').length;
    let items = $(navigation).find('.vc_pagination-item').toArray();

    for(let i = 0; i < page_count; i++) {
      if($(items[i]).hasClass('vc_active')) {
        console.log(i);

        if(i === (page_count - 1)) {
          $(items[0]).find('a').click();
        }
        else {
          $(items[i + 1]).find('a').click();
        }

        return true;
      }
    }
  });
  movePagination();
  moveTitle();
  $('.vc_pagination-trigger').on('click', changeByClick);
  $('.gcom-pageable-previous').on('click', changeByClick);
  $('.gcom-pageable-next').on('click', changeByClick);  
});

function changeByClick() {
  setTimeout(function () {
    movePagination();
    moveTitle();
  }, 100)
}

function movePagination() {        
  let titleHeight = $('.vc_active').find('.faq-slider__title').height(); 
  if ($(window).width() <= 768 )  {
    $('.faq-slider').find('.vc_pagination').css({'top' : titleHeight + 15 + 'px'});
    console.log(titleHeight);
  } else {
    $('.faq-slider').find('.vc_pagination').css({'top' : titleHeight + 5 + 'px'});
    console.log(titleHeight);
  }  
}
function moveTitle() {        
  let titleBlockHeight = $('.vc_active').find('.faq-slider__title').height() + 73;    
  $('.vc_active').find('.faq-slider__title').css({'top' : '-' + titleBlockHeight + 'px'});
  $('.vc_active').find('.faq-one').css({'margin-top' : titleBlockHeight + 'px' });
  console.log(titleBlockHeight);
}

$(window).resize(function() { 
  movePagination();
  moveTitle();
  $('.vc_pagination-trigger').on('click', changeByClick);
  $('.gcom-pageable-previous').on('click', changeByClick);
  $('.gcom-pageable-next').on('click', changeByClick);
});

$('.vc_tta-panel .vc_tta-panel-title a').on('afterShow.vc.accordion', function(){
  movePagination();
  moveTitle();
});


// WEBPACK FOOTER //
// ./scripts/wpbakery/pageable.js